var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import forge from 'node-forge';
import { BaseCryptoManager } from './base.js';
export class ForgeCryptoManager extends BaseCryptoManager {
    constructor() {
        super(...arguments);
        /**
         * Generates a pair of `JsonWebKey`, both can be used to encrypt and decrypt data.
         * @returns a pair of `JsonWebKey`
         */
        this.generateKeyPair = () => __awaiter(this, void 0, void 0, function* () {
            const keyPair = yield forge.pki.rsa.generateKeyPair({ bits: 1024, workers: 2 });
            const { publicKey, privateKey } = keyPair;
            return {
                publicKey: forge.pki.publicKeyToRSAPublicKeyPem(publicKey),
                privateKey: forge.pki.privateKeyToPem(privateKey),
            };
        });
        /**
         * Provides a way to encrypt data with `cryptoKey`.
         * @param cryptoKey - `JsonWebKey` generated by `generateKeyPair`
         * @param data - data to be encrypted
         * @returns encrypted data
         */
        this.encrypt = (cryptoKey, data) => __awaiter(this, void 0, void 0, function* () {
            const pbKey = forge.pki.publicKeyFromPem(cryptoKey);
            const encrypted = pbKey.encrypt(data, 'RSA-OAEP');
            return forge.util.encode64(encrypted);
        });
        /**
         * Decrypts the encrypted data with `cryptoKey`.
         * @param cryptoKey - `JsonWebKey` generated by `generateKeyPair`
         * @param data - encrypted data
         * @returns decrypted data
         */
        this.decrypt = (cryptoKey, data) => __awaiter(this, void 0, void 0, function* () {
            const priKey = forge.pki.privateKeyFromPem(cryptoKey);
            const decrypted = yield priKey.decrypt(forge.util.decode64(data), 'RSA-OAEP');
            return decrypted;
        });
    }
}
